import { render } from "./PollieWidget.vue?vue&type=template&id=45fde5a6&scoped=true"
import script from "./PollieWidget.vue?vue&type=script&lang=js"
export * from "./PollieWidget.vue?vue&type=script&lang=js"

import "./PollieWidget.vue?vue&type=style&index=0&id=45fde5a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fde5a6"]])

export default __exports__